<template>
  <SimpleModuleDashboard
    :module-id="Modules.SENSORES"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="actions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    actions: [
      { id: 'crudSensorsAssociateTankCustomer', reference: 'crudSensorsAssociateTankCustomer', route: 'SensorsStaffCrudSensorsAssociateTankCustomer', tone: 'primary' },
      { id: 'listSensorsTankCustomer', reference: 'listSensorsTankCustomer', route: 'SensorsStaffListSensorsTankCustomer', tone: 'secondary' },
      { id: 'crudTank', reference: 'crudTank', route: 'SensorsStaffCrudTank', tone: 'success' },
      { id: 'configurations', reference: 'configurations', route: 'SensorsStaffConfigurations', tone: 'warning' },
    ],
  }),
}
</script>
